import type { ResponseWithType, SubEvents, SubEventsRestResponse } from './types';

const subEvents = ({ data }: ResponseWithType<SubEventsRestResponse>): SubEvents => {
  const { subEvents, id } = data;
  return {
    id,
    subEvents: subEvents.map((subEvent) => ({
      ...subEvent,
      segments: subEvent.segments || [],
    })),
    __typename: 'SubEvents',
  };
};

export default subEvents;
